import React from "react";
import { strings } from "../../Translations/strings";
import "./CookiePolicy.scss";
import NavProducts from "../../Marketplace/NavProducts/NavProducts";
import Footer from "../../Common/Footer/Footer";

const CookiePolicy = () => {
  return (
    <>
      <NavProducts />
      <div className="cookie-policy-page">
        <div className="container">
          <div className="cookie-policy-content">
            <h1 className="page-title">{strings.nav_cookie_policy_label}</h1>
            <div className="content-section">
              <p className="intro-text">
                Ova politika objašnjava kako web stranice eepartner.ba koriste kolačiće.
              </p>
              
              <div className="policy-section">
                <h2>1. Šta su kolačići (cookies)</h2>
                <p>Kolačići su male tekstualne datoteke koje se pohranjuju na vašem uređaju kada posjetite našu stranicu.</p>
              </div>

              <div className="policy-section">
                <h2>2. Vrste kolačića koje koristimo</h2>
                <ul>
                  <li><strong>Neophodni kolačići</strong> – omogućavaju osnovne funkcije stranice (npr. navigaciju, pristup sigurnim dijelovima).</li>
                  <li><strong>Funkcionalni kolačići</strong> – pamte vaše postavke i preferencije (npr. jezik, region).</li>
                  <li><strong>Analitički kolačići</strong> – pomažu nam da razumijemo kako korisnici koriste stranicu radi poboljšanja funkcionalnosti.</li>
                  <li><strong>Marketinški kolačići</strong> – koriste se za prikaz relevantnih oglasa i mjerenje učinkovitosti kampanja.</li>
                </ul>
              </div>

              <div className="policy-section">
                <h2>3. Svrha obrade</h2>
                <p>Poboljšanje korisničkog iskustva, analiza saobraćaja na stranici i personalizacija sadržaja.</p>
              </div>

              <div className="policy-section">
                <h2>4. Trajanje pohrane</h2>
                <p>Svi kolačići se čuvaju 30 dana.</p>
              </div>

              <div className="policy-section">
                <h2>5. Način davanja i povlačenja saglasnosti</h2>
                <p>Prilikom prve posjete, prikazujemo obavijest o kolačićima i nudimo vam mogućnost izbora da prihvatite, odbijete ili prilagodite izbor kolačića.</p>
                <p>Ukoliko želite povući saglasnost na prihvaćene kolačiće, neophodno je da u svom pregledniku u segmentu Privatnost i sigurnost obrišite postavljene kolačiće.</p>
              </div>

              <div className="policy-section">
                <h2>6. Upravljanje kolačićima</h2>
                <p>Možete kontrolisati i brisati kolačiće putem postavki vašeg web preglednika.</p>
                <p>Prihvatanjem dajete saglasnost na upotrebu kolačića u skladu s ovom politikom. Saglasnost se ne odnosi za neophodne kolačiće.</p>
                <p>Odabirom opcije odbijanja isključujete upotrebu svih kolačića izuzev neophodnih.</p>
                <p>Ukoliko ne želite dati saglasnost na sve kolačiće, možete iste prilagoditi kroz ponuđena podešavanja.</p>
                <p>Onemogućavanje nekih kolačića može uticati na funkcionalnost stranice.</p>
              </div>

              <div className="policy-section">
                <h2>7. Treće strane</h2>
                <p>Naše stranice mogu koristiti kolačiće trećih strana (npr. Google Analytics, Meta Pixel) za analizu i oglašavanje. Te strane imaju vlastite politike privatnosti koje možete pregledati na njihovim stranicama:</p>
                <ul>
                  <li><a href="https://policies.google.com/privacy?hl=en-US" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy?hl=en-US</a></li>
                  <li><a href="https://www.facebook.com/privacy/explanation" target="_blank" rel="noopener noreferrer">https://www.facebook.com/privacy/explanation</a></li>
                </ul>
              </div>

              <div className="policy-section">
                <h2>8. Kontakt informacije</h2>
                <p><strong>www.partner.ba</strong></p>
                <p><strong>"Partner mikrokreditna fondacija" Tuzla</strong></p>
                <p>15 maj bb, 75000 Tuzla</p>
                <p>Službenik za zaštitu ličnih podataka: <a href="mailto:sszlp@partner.ba">sszlp@partner.ba</a></p>
              </div>

              <div className="policy-section">
                <h2>9. Izmjene politike</h2>
                <p>Zadržavamo pravo izmjene ove politike u skladu sa zakonskim propisima i tehničkim promjenama.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CookiePolicy;